import axios from 'axios'

const api = axios.create({
  baseURL: `/api`,
  // baseURL: import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Перехватчик запросов для добавления токена
api.interceptors.request.use(
  (config) => {
    // Сначала проверяем токен в заголовках по умолчанию
    if (config.headers.Authorization) {
      return config
    }
    
    // Если токена нет в заголовках, берем из localStorage
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Перехватчик ответов для обработки ошибок
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Токен истек или недействителен
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// Методы для работы с товарами
export const productsAPI = {
  // Получение списка товаров
  getProducts: (params = {}) => api.get('/products/', { params }),
  
  // Получение товара по ID
  getProduct: (id) => api.get(`/products/${id}`),
  
  // Создание товара
  createProduct: (formData) => api.post('/products/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  
  // Обновление товара
  updateProduct: (id, data) => api.put(`/products/${id}`, data),
  
  // Удаление товара
  deleteProduct: (id) => api.delete(`/products/${id}`),
  
  // Добавление изображений к товару
  addProductImages: (id, formData) => api.post(`/products/${id}/images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),

  // Удаление изображения товара
  deleteProductImage: (imageId) => api.delete(`/products/images/${imageId}`),

  // Варианты логотипа
  getLogoVariants: (productId) => api.get(`/products/${productId}/logo-variants`),
  createLogoVariant: (productId, formData) => api.post(`/products/${productId}/logo-variants`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  updateLogoVariant: (variantId, data) => api.put(`/products/logo-variants/${variantId}`, data),
  deleteLogoVariant: (variantId) => api.delete(`/products/logo-variants/${variantId}`),
  addLogoVariantImages: (variantId, formData) => api.post(`/products/logo-variants/${variantId}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteLogoVariantImage: (imageId) => api.delete(`/products/logo-variants/images/${imageId}`),

  // Импорт товаров из CSV
  importCsv: (formData) => api.post('/products/import-csv', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// API для подарочных карт
export const giftCardsAPI = {
  // Получить карты клиента (для корзины)
  getClientCards: (clientId) => api.get(`/gift-cards/client/${clientId}`),
  
  // Получить все карты (для менеджера)
  getAllCards: (params = {}) => api.get('/gift-cards/', { params }),
  
  // Создать карту
  createCard: (cardData) => api.post('/gift-cards/', cardData),
  
  // Обновить карту
  updateCard: (cardId, cardData) => api.put(`/gift-cards/${cardId}`, cardData),
  
  // Удалить карту
  deleteCard: (cardId) => api.delete(`/gift-cards/${cardId}`)
}

// API для основных фото
export const mainPhotosAPI = {
  // Загрузить основное фото клиента
  uploadMainPhoto: (formData) => api.post('/main-photos/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  
  // Получить основное фото клиента
  getClientMainPhoto: (clientId) => api.get(`/main-photos/client/${clientId}`),
  
  // Удалить основное фото клиента
  deleteClientMainPhoto: (clientId) => api.delete(`/main-photos/client/${clientId}`)
}

// API для категорий
export const categoriesAPI = {
  // Создать категорию
  createCategory: (categoryData) => api.post('/categories/', categoryData),
  
  // Получить категории клиента
  getClientCategories: (clientId) => api.get(`/categories/client/${clientId}`),
  
  // Обновить категорию
  updateCategory: (categoryId, categoryData) => api.put(`/categories/${categoryId}`, categoryData),
  
  // Удалить категорию
  deleteCategory: (categoryId) => api.delete(`/categories/${categoryId}`)
}

// API для логотипов
export const logosAPI = {
  // Создать логотип
  createLogo: (logoData) => api.post('/logos/', logoData),
  
  // Получить логотипы клиента
  getClientLogos: (clientId) => api.get(`/logos/client/${clientId}`),
  
  // Обновить логотип
  updateLogo: (logoId, logoData) => api.put(`/logos/${logoId}`, logoData),
  
  // Удалить логотип
  deleteLogo: (logoId) => api.delete(`/logos/${logoId}`)
}

// API для регистрации MC-Bauchemie
export const registerMCBauchemie = (registrationData) => {
  return api.post('/users/register-mc-bauchemie', registrationData)
}

// API для заказов
export const ordersAPI = {
  updateComment: (orderId, notes) => api.patch(`/orders/${orderId}/comment`, { notes }),
  updateTrackNumber: (orderId, trackingNumber) => api.patch(`/orders/${orderId}/track-number`, { tracking_number: trackingNumber }),
  updateDelivery: (orderId, deliveryAmount) => api.patch(`/orders/${orderId}/delivery`, { delivery_amount: deliveryAmount }),
  fetchCdekDelivery: (orderId) => api.get(`/orders/${orderId}/cdek-delivery`),
  updateManagerProcessing: (orderId, data) => api.patch(`/orders/${orderId}/manager-processing`, data)
}

// API для баланса внутренней валюты VIP клиентов
export const balanceAPI = {
  // Получить свой баланс (vip_rop) или баланс РОП (vip_manager_client)
  getBalance: () => api.get('/users/balance'),

  // Получить список РОП с балансами (для vip_client администратора)
  getRops: () => api.get('/users/vip/rops'),

  // Пополнить баланс РОП (для vip_client администратора)
  topupRop: (ropId, amount) => api.post(`/users/vip/rops/${ropId}/topup`, { amount })
}

// API для свойств клиента (Свойства / Отделы / Проекты)
// clientId — передаётся менеджером, для VIP Администратора не нужен (null)
export const clientPropertiesAPI = {
  getVipAdminTopupTypes: (vipClientId) =>
    api.get(`/client-properties/vip/${vipClientId}/admin-topup-types`),
  setVipAdminTopupTypes: (vipClientId, propertyTypes) =>
    api.put(`/client-properties/vip/${vipClientId}/admin-topup-types`, { property_types: propertyTypes }),
  getAll: (clientId = null) => api.get('/client-properties/', { params: clientId ? { client_id: clientId } : {} }),
  getMyManagersProperties: () => api.get('/client-properties/my-managers-properties'),
  /** Объединение свойств менеджеров и прямых привязок РОП (для баланса и заказа) */
  getMyRopVisibleProperties: () => api.get('/client-properties/my-rop-visible-properties'),
  getMyRopAssigned: () => api.get('/client-properties/my-rop-assigned'),
  getMyProperty: () => api.get('/client-properties/my-property'),
  create: (data, clientId = null) => api.post('/client-properties/', data, { params: clientId ? { client_id: clientId } : {} }),
  update: (id, data, clientId = null) => api.put(`/client-properties/${id}`, data, { params: clientId ? { client_id: clientId } : {} }),
  remove: (id, clientId = null) => api.delete(`/client-properties/${id}`, { params: clientId ? { client_id: clientId } : {} }),
  topup: (id, amount, clientId = null) => api.post(`/client-properties/${id}/topup`, { amount }, { params: clientId ? { client_id: clientId } : {} }),
  assignUser: (id, userId, clientId = null) => api.post(`/client-properties/${id}/assign`, { user_id: userId }, { params: clientId ? { client_id: clientId } : {} }),
  unassignUser: (id, userId, clientId = null) => api.delete(`/client-properties/${id}/users/${userId}`, { params: clientId ? { client_id: clientId } : {} }),
  getAvailableUsers: (id, clientId = null) => api.get(`/client-properties/${id}/available-users`, { params: clientId ? { client_id: clientId } : {} }),
}

// API для контактов получателя товара на складе
export const recipientContactsAPI = {
  getAll: () => api.get('/recipient-contacts/'),
  create: (data) => api.post('/recipient-contacts/', data),
  remove: (id) => api.delete(`/recipient-contacts/${id}`),
}

// API для настроек VIP клиента (менеджер)
export const vipSettingsAPI = {
  getMySettings: () => api.get('/users/vip/my-settings'),
  getClientSettings: (clientId) => api.get(`/users/vip/${clientId}/settings`),
  updateClientSettings: (clientId, data) => api.patch(`/users/vip/${clientId}/settings`, data),
}

export const vipStatsAPI = {
  getBudgetStats: (params = {}) => api.get('/users/vip/budget-stats', { params }),
  getShipmentStats: (params = {}) => api.get('/users/vip/shipment-stats', { params }),
}

export default api
